import {useCallback} from 'react';
import * as Sentry from '@sentry/react';
import {Navigate, useParams} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {displayError, IV_PHOTO_SOURCE, IV_DOCUMENT_IMAGE_TYPES} from '@guestapp/sdk';
import {blurSelfiePhoto} from 'pages/IdentityVerification/utils';
import {useSummary} from '../../../../context/summary';
import {useDocumentSelfieDetection} from 'hooks';
import {useIVStore} from 'store/identityVerification';
import {PATHS} from '../../../../Routes';
import PhotoBox from '../../../../components/PhotoBox';
import {HelperText} from '../styled';

const videoConstraints = {
  facingMode: 'user',
};

function SelfieScanView() {
  const {uploadType, id} = useParams();
  const {t} = useTranslation();
  const {reservationId, countryCode, data: summary} = useSummary();

  const isUpload = uploadType === 'upload';
  const {sendSelfieToDetectFace, ProcessModal, RetryModal, ErrorModal, isProcessing} =
    useDocumentSelfieDetection({
      docType: IV_DOCUMENT_IMAGE_TYPES.selfie,
    });
  const frontPhoto = useIVStore(state => state.imagesDetails.front);

  const handleChangePhoto = useCallback(
    async ({image, source}: {image: string; source: IV_PHOTO_SOURCE}) => {
      if (countryCode) {
        try {
          const blurredPhoto = await blurSelfiePhoto({
            photo: image,
          });
          if (blurredPhoto) {
            sendSelfieToDetectFace({
              source,
              countryCode,
              reservationId,
              image: blurredPhoto,
            });
          }
        } catch (error) {
          displayError(error as string);
        }
      } else {
        console.error('countryCode is missing', summary);
        Sentry.captureMessage('countryCode is missing', {extra: {summary}});
      }
    },
    [countryCode, reservationId, sendSelfieToDetectFace, summary],
  );

  if (!frontPhoto.uploaded) {
    return <Navigate to={`../../${PATHS.verification.main}/${id ?? ''}`} />;
  }

  return (
    <>
      <HelperText className="iv-selfie-view__helper">
        {t('keep_your_face_inside_oval_frame')}
      </HelperText>
      {!isProcessing && (
        <PhotoBox
          mobileHelperTitle={t('selfie')}
          mobileHelperText={t('keep_your_face_inside_oval_frame')}
          onUploadPhoto={handleChangePhoto}
          isUpload={isUpload}
          additionalConstraints={videoConstraints}
          roundedScanArea
        />
      )}
      <ProcessModal />
      <RetryModal />
      <ErrorModal />
    </>
  );
}

export {SelfieScanView};
